// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-3CYRh";
var _4 = "header-1AEqt";
var _5 = "text-39wh7";
var _6 = "footer-28n1q";
var _7 = "button-xzd8I";
var _8 = "button_cancel-3oPgF";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "header", _5 as "text", _6 as "footer", _7 as "button", _8 as "button_cancel" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "header": _4, "text": _5, "footer": _6, "button": _7, "button_cancel": _8 }
